// src/components/menus/SettingsPageRecycleBinSubMenu.tsx
import React from 'react';
import {
  CompactSubMenuContainer,
  CompactSubMenuTab,
  SubMenuCap,
} from './shared/MenuElements';

interface TabItem {
  label: string;
  minWidth?: string;
}

interface SettingsPageRecycleBinSubMenuProps {
  tabs: TabItem[];
  activeTab: number;
  onTabChange: (index: number) => void;
}

const SettingsPageRecycleBinSubMenu: React.FC<
  SettingsPageRecycleBinSubMenuProps
> = ({ tabs, activeTab, onTabChange }) => {
  return (
    <CompactSubMenuContainer>
      {tabs.map((tab, idx) => (
        <CompactSubMenuTab
          key={tab.label}
          isActive={activeTab === idx}
          minWidth={tab.minWidth}
          onClick={() => onTabChange(idx)}
          role="tab"
          aria-selected={activeTab === idx}
        >
          {tab.label}
        </CompactSubMenuTab>
      ))}
      <SubMenuCap height="3.4rem" />
    </CompactSubMenuContainer>
  );
};

export default SettingsPageRecycleBinSubMenu;
